// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmail":"yz_a bho_px bho_a bho_w bho_cw bho_sb","PasswordResetEmail__title":"yz_b bho_uj bho_qk bho_tu","PasswordResetEmail__subtitle":"yz_c bho_tu"};